<template>
  <div
    class="wrapper"
    ref="list"
  >
    <vehicle-filters />
    <div class="list">
      <span class="asterisk-message">{{ asterisk }}</span>
      <div v-if="filteredVehicles.length">
        <transition-group
          name="tr-cards"
          tag="ul"
        >
          <li
            v-for="vehicle in filteredVehicles"
            :key="vehicle.id"
          >
            <vehicle-card
              :availability="availabilityStatus"
              :vehicle="vehicle"
            />
          </li>
        </transition-group>
      </div>
      <div
        v-else
        class="nothing"
      >
        {{ no_result }}
      </div>
      {{ asterisk }}
    </div>
  </div>
</template>
<script>
import VehicleCard from './VehicleCard';
import VehicleFilters from './VehicleFilters/VehicleFilters';

export default {
  name: 'VehicleList',
  components: {
    VehicleFilters,
    VehicleCard,
  },
  watch: {
    api: {
      handler: 'onApiReady',
      immediate: true,
    },
  },
  mounted() {
    this.$store.commit('ui/SET_LIST_ELEMENT', this.$refs.list)
  },
  data() {
    return {
      asterisk: this.$t('commons.suggested_price'),
      no_result: this.$t('commons.no_result'),
      apiReady: false,
      fetchedVehicles: [],
    };
  },
  props: {
    vehicleList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    datesAndBusinessReady() {
      return this.$store.getters['booking/datesAndBusinessReady']
    },
    api() {
      return this.$store.state.api;
    },
    canGetPrices() {
      return this.$store.getters['vehicles/canGetPrices'];
    },
    categories() {
      return this.$store.state.vehicles.filters.categories;
    },
    pickupBusiness() {
      return this.$store.state.booking.pickUp.business;
    },
    vehicles() {
      return this.$store.state.vehicles.list.allVehicles || [];
    },
    prices() {
      return this.$store.state.vehicles.prices.prices || [];
    },
    availabilityStatus() {
      return this.$store.state.vehicles.availability.availabilityStatus;
    },
    filteredVehicles() {
      return this.vehicles
        .filter(this.filterCategories)
        .filter(this.filterElectric)
        .filter(this.filterbaggages)
        .filter(this.filterSeats)
        .filter(this.filterDoors);
    },
    activeFilters() {
      return this.$store.getters['vehicles/filters/activeFilters'];
    },
    stickyHeaderActivation() {
      return this.datesAndBusinessReady === null
    },
  },
  methods: {
    onApiReady() {
      if (!this.api) {
        return;
      }
      if (!this.vehicles.length) {
        this.$store.dispatch('vehicles/GET_VEHICLE_LIST');
      }
      if (this.canGetPrices) {
        this.$store.dispatch('vehicles/GET_PRICES', this.pickupBusiness);
      }
      this.getCategories();
    },
    showStickyHeader() {
      const changeAgences = window.location.search === '?changer_agences';
      const changeDate = window.location.search === '?changer_date';
      if (changeAgences || changeDate) {
        this.$store.commit('stepping/SET_HEADER', true)
      }
      if (window.localStorage.rentDropTime) {
        return
      }
      this.$store.commit('stepping/SET_HEADER', true)
    },

    getCategories() {
      if (this.apiReady || !this.api) {
        return;
      }
      this.$store.dispatch('vehicles/filters/GET_CATEGORIES');
    },
    filterCategories(vehicle) {
      const activeCats = this.activeFilters.categories;

      if (!activeCats.length) {
        return true;
      }

      return activeCats.findIndex((i) => i.id === vehicle.category.id) !== -1;
    },
    filterElectric(vehicle) {
      const electric = this.activeFilters.filters.find(
        (i) => i.id === 'is_electric',
      );
      if (!electric) {
        return true;
      }
      return vehicle.motorization >= 1;
    },
    filterbaggages(vehicle) {
      return this.filterMinQuantity('baggages', vehicle);
    },
    filterSeats(vehicle) {
      return this.filterMinQuantity('seats', vehicle);
    },
    filterDoors(vehicle) {
      const doors = this.activeFilters.filters.find((i) => i.id === 'doors');
      if (!doors) {
        return true;
      }
      return vehicle.doors === doors.value;
    },
    filterMinQuantity(param, vehicle) {
      const filter = this.activeFilters.filters.find((i) => i.id === param);
      if (!filter) {
        return true;
      }
      return vehicle[param] >= filter.value;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../_src/sass/config/vars";
@import "../../../../_src/sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

ul {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;

  @include teq-breakpoint($medium) {
    align-items: stretch;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 20px;
  }

  @include teq-breakpoint($large) {
    justify-content: flex-start;
    margin: 20px 0;
  }
}

li {
  align-items: stretch;
  display: flex;
  justify-content: center;
  margin: 30px 0 0 0;
  max-width: 100%;
  width: 100%;

  @include teq-breakpoint($medium) {
    justify-content: flex-start;
    max-width: calc(100% / 2);
  }

  @include teq-breakpoint($large) {
    justify-content: flex-start;
    margin: 0 20px 0 0;
    max-width: calc(100% / 3 - 14px);

    &:nth-child(3n) {
      margin-right: 0;
    }

    &:nth-child(n + 4) {
      margin-top: 20px;
    }
  }
}

.list {
  font-family: $f-graphie-book;
  margin: 20px 20px;

  @include teq-breakpoint($medium) {
    margin: 20px auto 20px;
    max-width: calc(100% - 186px);
  }

  .asterisk-message {
    display: flex;
    margin: 0 auto;
    width: 400px;

    @include font-size(11px);

    @include teq-breakpoint($medium) {
      margin: auto 20px;
      width: auto;
    }

    @include teq-breakpoint($large) {
      margin: 0;
      width: auto;
    }
  }
}

.nothing {
  display: flex;
  font-size: 2rem;
  justify-content: center;
  margin: 40px 0;
}

.tr-cards-enter-active,
.tr-cards-leave-active {
  transition: all 0.5s;
}

.tr-cards-enter,
.tr-cards-leave-to /* .fade-leave-active below version 2.1.8 */ {
  max-width: 0;
  transform: scale(0);
}
</style>
